// extracted by mini-css-extract-plugin
export default {"dropdownMenu":"style_dropdownMenu__XOM6r"};